import AuthorItem from "./author-item.component";

export default AuthorItem;
